import { useContext } from "react";
import { EntityPathDeriverContext } from "../context/entity-path-deriver-context";
export var useEntityPathDeriver = function () {
  return useContext(EntityPathDeriverContext) || function (entity) {
    return entity.path;
  };
};